import React, {useEffect} from 'react'
import { useParams } from 'react-router-dom'
import error404 from '../../img/FN404.png'
import './pageError.css'

//muestra un error 404 si lo que busca no existe!
const PageError = ({mensaje = 'No se ha encontrado!'}) => {
    const {id} = useParams()

    useEffect(() => {
    }, [id])
    
    
    return (
        <div className="container">
          <div className="row notFound">
            <h2><span className='not-found'>{id}</span> {mensaje}</h2>
            <img src={error404} alt="error404"/>
           </div> 
        </div>
    )
}
export default PageError;